import React, { ReactElement } from "react";
import { randomIcon } from "../../lib/randomIcon";
import "./loading.scss";

interface LoadingProps {
	children?: ReactElement;
}

export const Loading = (props: LoadingProps) => {
	return (
		<div className="loading">
			<div className="loading__animation rotate--3">
				{props.children ? (
					props.children
				) : (
					<i className="material-icons">{randomIcon()}</i>
				)}
			</div>
		</div>
	);
};
